/**
 * The client half's single answer to "has this interview session ended?".
 *
 * Every client reader of that question derives from here — the interview room's readiness poll and
 * the proctor's waiting-screen poll — so a new ending is added in one place rather than found
 * missing from one list months later. The server half declares the same set for itself (this file
 * cannot be imported across the build boundary), and a test pins the two against drift.
 *
 * ⛔ Leaf module on purpose: no imports and no I/O, so anything may depend on it.
 */

/*
 * Membership is the contract; order is not. `failed` has no writer today and is carried because
 * readers already refused it — dropping it would narrow existing behaviour for nothing.
 */
export const SESSION_END_STATES = Object.freeze([
  'completed',
  'failed',
  'expired_before_start',
  'terminated_identity_failed',
  'terminated_screen_share_not_granted',
  // The interview began and was closed because the interviewer never asked a question. ⛔ Not
  // `failed`: that word says something about the candidate, and nothing about them happened here.
  'ended_system_fault',
]);

/*
 * Total over its input. A screen that has not yet heard a status must not render an ending, so
 * anything falsy answers no rather than throwing.
 */
export const isSessionEnded = status => (status ? SESSION_END_STATES.includes(status) : false);
